import React, { useState } from 'react';
import { PendingLinkModal } from './Compliance';
import moment from "moment";
import { Modal } from "react-bootstrap";
import { AUDITOR_ROLE, BUSINESS_ROLE, COMPLIANCE_APPROVED, COMPLIANCE_PENDING, COMPLIANCE_REJECTED, INVESTOR_TYPE_COMPANY, INVESTOR_TYPE_INDIVIDUAL } from '../utilities';


const KycDetailsModal = (props) => {

  let data = props.data;

  const handleClose = () => {
    props.onHide();
  };

  const handleDownload = async (doc) => {
    let url = doc.document_url;
    let file = doc.document_type;

    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = objectUrl;
      a.download = data.business_name + "_" + doc.document_type; // file name
      a.click();
      URL.revokeObjectURL(objectUrl);
    } catch (err) {
      console.log(err);
    }
  };
  const [kycBusinessModal, setKycBusinessModal] = useState(false);
  const [kYCEyeClick, setKYCEyeClick] = useState([]);
  const [businessName, setBusinessName] = useState();
  const [riskData, setRiskData] = useState(false);

  // const kycDocumentClick = (data, bName) => {
  //   setKYCEyeClick(data);
  //     setBusinessName(bName)
  // };

  const kycDocumentClick = (doc, fullData, bName, riskValue) => {
    setKYCEyeClick({
      ...doc,        // KYC document details
      ...fullData    // Full investor data 
    });
    setBusinessName(bName);
    setRiskData(riskValue);
  };

  return (
    <Modal
      {...props}
      dialogClassName="modal-190w"
      aria-labelledby="example-custom-modal-styling-title"
      size="sm"
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header onHide={handleClose} closeButton className="modal_title">
        <Modal.Title id="example-custom-modal-styling-title">
          <div className=" ps-2 d-flex justify-content-between">
            <div className="heading_new_loan ">
              <h5 className="mb-0 me-5 pe-5">KYC Form</h5>
            </div>
          </div>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body
        className=" "
        style={{}}
      >



        <div className=" p-3  ">

          <div className="kyc_upload_cls col  ">
            {data?.kyc_forms?.map((doc, index) => {


              return (
                <tr key={index}>
                  <td >{doc.updated_date_time == undefined ? '-' : moment(doc.updated_date_time).format("DD-MM-YYYY")}</td>
                  <td >{doc.status == undefined ? '-' : doc.status === COMPLIANCE_PENDING ?
                    <b className='text-primary'>Pending</b> :
                    doc.status === COMPLIANCE_APPROVED ?
                      <b className='text-success'>Approved</b> :
                      doc.status === COMPLIANCE_REJECTED ?
                        <b className='text-danger'>Rejected</b> : ""

                  }</td>
                  <td className='d-flex align-self-center'>
                    <div className="col d-flex justify-content-center">
                      <span className="">
                        {" "}
                        <a
                          style={{ display: "table-cell", cursor: "pointer" }}
                          href={doc.document_url}
                          target="_blank"
                        >
                          <img src="./images/eye.svg" alt=""
                            onClick={() =>
                              setKycBusinessModal(
                                true,
                                kycDocumentClick(doc, data, data.type === INVESTOR_TYPE_COMPANY || data.type === INVESTOR_TYPE_INDIVIDUAL ? data.investor_company_name : data.business_name, data?.kyc_forms?.[0]?.risk_assessment_completed)
                              )
                            }

                          />
                        </a>
                      </span>
                      {/* <span
                      className="Cpointer ps-3"
                      onClick={() =>
                        handleDownload(doc)
                      }
                    >
                      <img src="./images/down.svg" alt="" />
                    </span> */}
                    </div>
                  </td>
                </tr>
              )
            })}
          </div>
        </div>

        <PendingLinkModal
          singleBsnsData={kYCEyeClick}
          bname={businessName}
          data={kYCEyeClick}
          show={kycBusinessModal}
          onHide={() => setKycBusinessModal(false)}
          riskAssessmentCompleted={riskData}
        />


      </Modal.Body>
      <Modal.Footer className="d-flex notift_btn_txtsize">
        <div>
          <button
            className="btn btn_background_sm mx-2  py-2"
            onClick={handleClose}
          >
            Close
          </button>
        </div>


      </Modal.Footer>
    </Modal>
  );
};

export default KycDetailsModal;
